import React, { useState } from 'react';
import { checkDevModeStatus } from '../../services/devModeGuardService';

/**
 * Modal bloqueante de seguridad cuando el Modo Desarrollador está activado en el dispositivo móvil.
 * No se puede cerrar con clic afuera, obligando al usuario a desactivarlo o cerrar sesión.
 */
export const DevModeGuardModal = ({ isOpen, onResolved, onLogout }) => {
  const [checking, setChecking] = useState(false);
  const [feedback, setFeedback] = useState(null);

  if (!isOpen) return null;

  const handleRetry = async () => {
    setChecking(true);
    setFeedback(null);
    try {
      const status = await checkDevModeStatus();
      if (!status.isDevMode && !status.isMockLocation) {
        if (typeof onResolved === 'function') {
          onResolved();
        }
      } else {
        setFeedback('⚠️ Aún sigue activo en los Ajustes de tu teléfono. Por favor desactívalo y presiona de nuevo.');
      }
    } catch (e) {
      setFeedback('Error al verificar. Intenta nuevamente.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.92)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 999999,
      padding: '20px',
      animation: 'fadeIn 0.25s ease-out'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        maxWidth: '420px',
        width: '100%',
        padding: '28px 24px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(239, 68, 68, 0.2)',
        textAlign: 'center',
        position: 'relative'
      }}>
        {/* Ícono de Alerta */}
        <div style={{
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          backgroundColor: '#fee2e2',
          color: '#dc2626',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 18px',
          fontSize: '36px',
          boxShadow: '0 10px 15px -3px rgba(220, 38, 38, 0.2)'
        }}>
          🛡️
        </div>

        {/* Título */}
        <h2 style={{
          fontSize: '1.35rem',
          fontWeight: 800,
          color: '#0f172a',
          margin: '0 0 10px 0',
          lineHeight: 1.2
        }}>
          Modo Desarrollador Detectado
        </h2>

        {/* Descripción */}
        <p style={{
          fontSize: '0.92rem',
          color: '#475569',
          lineHeight: 1.5,
          margin: '0 0 16px 0'
        }}>
          Por políticas de seguridad, no está permitido el uso de la aplicación con las <strong>Opciones de Desarrollador</strong> activas en tu teléfono.
        </p>

        <div style={{
          backgroundColor: '#f8fafc',
          border: '1px solid #e2e8f0',
          borderRadius: '12px',
          padding: '12px 14px',
          marginBottom: '20px',
          textAlign: 'left',
          fontSize: '0.84rem',
          color: '#334155'
        }}>
          <p style={{ margin: '0 0 6px 0', fontWeight: 600, color: '#1e293b' }}>
            📲 Pasos para desactivarlo:
          </p>
          <ol style={{ margin: 0, paddingLeft: '18px', lineHeight: 1.4 }}>
            <li>Abre <strong>Ajustes / Configuración</strong> en tu celular.</li>
            <li>Busca <strong>Opciones de desarrollador</strong> (o en Sistema).</li>
            <li>Apaga el interruptor principal de <strong>Desactivado</strong>.</li>
          </ol>
        </div>

        {feedback && (
          <div style={{
            backgroundColor: '#fef2f2',
            color: '#b91c1c',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            padding: '10px 12px',
            fontSize: '0.82rem',
            marginBottom: '16px',
            fontWeight: 500
          }}>
            {feedback}
          </div>
        )}

        {/* Botones de acción */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button
            onClick={handleRetry}
            disabled={checking}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#2563eb',
              color: '#ffffff',
              border: 'none',
              borderRadius: '12px',
              fontSize: '0.98rem',
              fontWeight: 700,
              cursor: checking ? 'not-allowed' : 'pointer',
              opacity: checking ? 0.7 : 1,
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.35)'
            }}
          >
            {checking ? '⏳ Verificando dispositivo...' : '🔄 Ya lo desactivé (Reintentar)'}
          </button>

          {onLogout && (
            <button
              onClick={onLogout}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: 'transparent',
                color: '#64748b',
                border: '1px solid #cbd5e1',
                borderRadius: '12px',
                fontSize: '0.9rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              🚪 Cerrar Sesión
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
export default DevModeGuardModal;
